//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalAcceptPrivacy',
  data() {
    return {
      title: 'New privacy policy',
      content: this.$t(`New privacy policy. Read it carefully and accept it to be able to play and make more deposits!`),
      button_text: 'Go to the new privacy policy',
      isOpen: false,
      closeModal: false
    }
  },
  watch: {
    isOpen: function(){
      if (this.isOpen) {
        this.$store.commit('addModal', this.$options.name)
      } else {
        this.$store.commit('removeModal', this.$options.name)
      }
    }
  },
  methods: {
    preventClose(event) {
      if (this.isOpen) {
        event.cancel()
      }      
    },    
    checkOpenModal() {
      for (let i = 0; i < this.$store.state.openedModals.length; i++) {
        if (this.$store.state.openedModals[i] !== this.$options.name) {
          return false
        }
      }
      return true
    },    
    opened() {
      this.isOpen = true;
    },    
    beforeOpen (event) {
      console.info(event)
      window.dispatchEvent(new Event('resize'));

      if (_.get(event, 'params')) {
        this.title = _.get(event, 'params.title', '')
        this.content = _.get(event, 'params.content', '')        
      }

    },
    close() {
      this.isOpen = false;       
      this.$modal.hide('modal-accept-privacy')
      this.$router.push({path: '/ayuda/politica-de-privacidad/'})
    },
    async submit() {}
  }
}
